import { z } from 'zod';

import { createFileRoute, Navigate } from '@tanstack/react-router';

import { DoctorInterface } from './-components/doctors-interface';
import { useAuthContext } from '@web/auth';
import { hasPermission } from '@shared/auth';

export const doctorsSearchSchema = z.object({
  firstName: z.string({ description: 'First Name' }).optional(),
  lastName: z.string({ description: 'Last Name' }).optional(),
  status: z
    .enum(['active', 'inactive'], {
      description: 'Status',
    })
    .optional(),
});

export const Route = createFileRoute('/dashboard/admin/doctors/')({
  component: View,

  validateSearch: doctorsSearchSchema,
});

function View() {
  const { user } = useAuthContext();

  if (!user) return null;

  if (!hasPermission(user, 'doctors_module', 'access')) {
    return <Navigate to="/dashboard" />;
  }

  return <DoctorInterface />;
}
